export default __webpack_public_path__ + "static/media/newLead25.20d61a99.png";